import React, { useState, useContext } from 'react';
import { Box, Typography, Tooltip, IconButton } from '@mui/material';
import { ThemeContext } from 'styled-components';
import { lazy, Suspense } from 'react';
const QRCode = lazy(() => import('react-qr-code'));
import ScratchOffText from './ScratchOffText';
import OTPInputField from './OTPInputField';
import RefreshIcon from '@mui/icons-material/Refresh';
import InputWithActions from "./InputWithActions";
import WithActions from "../Wrappers/WithActions";

const MFACompound = ({
    qrCodeUrl = null,
    qrCodeSecret = null,
    verificationCode = '',
    onChangeAuthForm,
    onResend,
    showQR = false,
    showOTP = true,
    title = 'Multi-Factor Authentication',
    description = 'Enter the 6-digit code from your authenticator app',
    sx = {}
}) => {
    const theme = useContext(ThemeContext);

    return (
        <Box sx={{ ...sx }}>
            {/* QR Code Section - Only show if QR data is provided, showQR is true, and not inactive */}
            {showQR && qrCodeUrl && qrCodeSecret && (
                <Box sx={{ mt: 2, p: 2, bgcolor: 'rgba(255,255,255,0)', borderRadius: 2, mb: 3 }}>
                    <div style={{ marginTop: '20px', textAlign: 'center' }}>
                        <Suspense fallback={<div style={{ width: 256, height: 256, backgroundColor: theme.colors.backgroundPrimary }} />}>
                            <QRCode
                                value={qrCodeUrl}
                                size={256}
                                fgColor={theme.colors.secondary}
                                bgColor={theme.colors.backgroundPrimary}
                                level="M"
                            />
                        </Suspense>
                    </div>

                    {/* Secret Code Section */}
                    <Box sx={{ mt: 3, textAlign: 'center' }}>
                        <ScratchOffText
                            hiddenText="Can't scan? Get the secret code"
                            revealedText={qrCodeSecret}
                            copyText="Secret code copied to clipboard!"
                            sx={{
                                color: theme.colors.text,
                                fontSize: '0.9rem',
                            }}
                        />
                    </Box>
                </Box>
            )}

            {/* OTP Input Section - Only show if showOTP is true */}
            {showOTP && (
                <Box sx={{
                    mt: 2,
                    mb: 3,
                    opacity: !showQR ? 0.5 : 1,
                    pointerEvents: !showQR ? 'none' : 'auto'
                }}>
                    <Typography
                        variant="body2"
                        align="center"
                        sx={{
                            color: theme.colors.text,
                            mb: 2,
                            fontSize: '0.9rem'
                        }}
                    >
                        {description}
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                        <Tooltip title={!showQR ? "MFA setup is disabled" : "Enter the 6-digit code from your authenticator app"}>
                            <Box>
                                <WithActions
                                    successTooltip="verification code verified"
                                    inputType="code"
                                    showRefreshButton={false}
                                    forceSpacing={true}
                                >
                                    <OTPInputField
                                        verificationCode={verificationCode}
                                        onChangeAuthForm={onChangeAuthForm}
                                        name="mfaVerificationCode"
                                        sx={{ flexGrow: 1, mr: 1 }}
                                    />
                                </WithActions>
                            </Box>
                        </Tooltip>
                    </Box>
                </Box>
            )}
        </Box>
    );
};

export default MFACompound;
